<template>
    <div>
        <FormulateInput
        v-if="personalizedType !== 'clipartCategory'"
        :name="layer.id"
        :label="label"
        type="imagecalendarpicker"
        :aspectRatio="aspectRatio"
        :configsCalendar="configsCalendar"
        />
    </div>
</template>

<script>
import { get } from 'lodash';
export default {
    name: 'ImageCalendarPickerField',
    props: {
        layer: {
            type: Object,
            required: true
        },
        artwork: {
            type: Object,
            required: true
        },
        personalized: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        personalizedType() {
            return this.layer.personalized.type
        },
        required() {
            return get(this.layer, 'personalized.required', false)
        },
        initialValue() {
            const { personalized, layer } = this
            return get(personalized, layer.id)
        },
        label() {
            return get(this.layer, 'personalized.label', this.layer.title)
        },
        aspectRatio() {
            const { layer } = this
            return layer.width / layer.height
        },
        configsCalendar(){
            const { layer } = this;
            return layer.configsCalendar || {};
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Form/ImageCalendarPickerField.vue